import {httpErrorCheck} from '../utils/errors';

import {defaultOptions, defaultHeaders} from './default-options';
import {mergeHeaders} from './merge-headers';

export function patch(url: string, body: any[], options: RequestInit): Promise<Response> {
    const defaultPatchHeaders = new Headers(defaultHeaders);
    defaultPatchHeaders.set('content-type', 'application/json-patch+json');

    // @ts-ignore
    return fetch(url, {
        ...defaultOptions,
        ...options,
        method: 'PATCH',
        // @ts-ignore
        headers: mergeHeaders(options.headers, defaultPatchHeaders),
        body: JSON.stringify(body),
    }).then(httpErrorCheck);
}
